import actionTypes from '../actions/sopReport/actionType';

const initialState = {
  loading: false,
  name: '',
  total: 0,
  pageSize: 20,
  pageNum: 1,
  filterData: {},
  searchData: {
    storeCode: undefined,
    startDate: undefined,
    version: undefined,
    regionalCode: undefined,
    midRegionalCode: undefined,
    city: undefined,
    endDate: undefined,
  },
  templateType: [],
  columnsData: [],
  tableList: [],
  sysData: [],
  systemCode: undefined,
  commonCode: undefined,
  detailData: {},
  userInfo: [],
  itemData: [],
  jobDetail: {},
  reportState: '',
  usercCode: undefined,
  versionData: [],
  exportvisible: false,
  commonTypeCode: '',
  taskData: [],
  taskItemName: '',
  exportDetailData: {},
  exportLoading: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
